import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormLabel,
  Grid2,
  IconButton,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseIcon } from "Assets/Icons/Home/CloseIcon.svg";
import { ReactComponent as PlusIcon } from "Assets/Icons/Settings/PlusIcon.svg";
import { ReactComponent as EditIcon } from "Assets/Icons/Settings/EditIcon.svg";
import { ReactComponent as DeleteIcon } from "Assets/Icons/Settings/DeleteIcon.svg";
import { ReactComponent as AlertIcon } from "Assets/Icons/Leaderboard/AlertIcon.svg";
import PhoneNumberInput from "Components/Common/PhoneNumberInput";
import PrimaryIcon from "Components/Common/PrimaryIcon";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import axios from "Services/api";
import * as yup from "yup";
import { addFriendsDetail } from "Slices/thunks";

const initialValue = {
  FullName: "",
  CountryCodeID: "",
  Mobile: "",
  Email: "",
}

const FriendsDetail = ({ open, setOpen, friendDetails = [], setFriendDetails, setAddProgram, currentTab = 1 }) => {
  const dispatch = useDispatch();
  const [tab, setTab] = useState(currentTab);
  const [friendIndex, setFriendIndex] = useState();
  const [minMobileLength, setMinMobileLength] = useState(8);


  const { Common, Location, Translation, ReferredUser, ReferredUserYetToJoin, EnrolledUser } = useSelector((state) => ({
    Common: state.Common.common || {},
    Location: state.Common.location || {},
    Translation: state.Translation.translation?.Referral || {},
    ReferredUser: state.ReferralReward.referredUser,
    ReferredUserYetToJoin: state.ReferralReward.referredUserYetToJoin,
    EnrolledUser: state.ReferralReward.enrolledUser,
  }));

  const Schema = useMemo(() => {
    return yup.object({
      FullName: yup
        .string()
        .required(Translation?.FullNameRequired || "Full name is required field."),
      Email: yup
        .string()
        // .required(Translation?.EmailRequired || "Email is required field.")
        .email(Translation?.ValidEmail || "Email should be valid email."),
      CountryCodeID: yup
        .string()
        .required(Translation?.DialcodeRequired || "Dial code is required field."),
      Mobile: yup
        .string()
        .required(Translation?.PhoneNumberRequired || "Phone number is required field.")
        .min(minMobileLength, Translation?.ValidPhoneNumber?.replace('XXX', minMobileLength) || `Phone number should be at least ${minMobileLength} digits.`)
    });
  }, [Translation, minMobileLength])


  const {
    values,
    setValues,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setErrors,
    resetForm,
    touched,
    setFieldValue,
    setFieldTouched
  } = useFormik({
    initialValues: initialValue,
    enableReinitialize: true,
    onSubmit: async (data) => {
      console.log('data: ', data);
      const referredUsers = friendIndex >= 0 ? 
      [...ReferredUser, ...ReferredUserYetToJoin, ...EnrolledUser, ...friendDetails?.filter((_, i) => i !== friendIndex)] :
      [...ReferredUser, ...ReferredUserYetToJoin, ...EnrolledUser, ...friendDetails]
      const mobiles = referredUsers.map((item) => item.Mobile)
      
      if (mobiles.includes(data.Mobile)) {
        setErrors({Mobile: Translation?.PhoneNumberAlreadyExist || "Phone number already exists."});
        return;
      }
      
      if (friendIndex >= 0) {
        const updatedFriendDetails = friendDetails.map((item, i) => i === friendIndex ? data : item) 
        setFriendDetails(updatedFriendDetails);
        setFriendIndex();
        resetForm();
        setTab(2);
      } else {
        setFriendDetails([...friendDetails, data]);
        resetForm();
        setTab(2);
      }
    },
    validationSchema: Schema,
  });
  console.log('errors: ', errors);

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = async () => {
    try {
      dispatch(addFriendsDetail({FriendsDetail: friendDetails})).unwrap();
      setOpen(false);
      setAddProgram(true);
      // toast.success(Translation?.AddedSuccessfully)
    } catch (error) {
      // console.log('error: ', error);
      // toast.error(Translation?.SomethingWentWrong)
    }
  }

  const addFriendDetail = () => {
    const country = Common?.Country.find((item) => item.CountryCode === Location.country_code)
    setFieldValue("DialCode", country?.DialCode)
    setFieldValue("CountryCodeID", country?.ID)
    setMinMobileLength(country?.NumbersLimit)
    setTab(1);
  }

  const editFriendDetail = (detail, index) => {
    const country = Common?.Country.find((item) => item.ID === detail.CountryCodeID)
    setMinMobileLength(country?.NumbersLimit);
    setFriendIndex(index);
    setValues(detail);
    setTab(1);
  }

  const deleteFriendDetail = (detail, index) => {
    const updatedFriendDetails = friendDetails.filter((item, i) => i !== index) 
    if (!updatedFriendDetails.length) {
      setTab(1);
    }
    setFriendDetails(updatedFriendDetails);
  }

  useEffect(() => {
    resetForm()
    setTab(1);
    if (Array.isArray(Common?.Country) && Location?.country_code) {
      const country = Common?.Country.find((item) => item.CountryCode === Location.country_code)
      setFieldValue("DialCode", country?.DialCode)
      setFieldValue("CountryCodeID", country?.ID)
      setMinMobileLength(country?.NumbersLimit)
    }
  }, [open])
  
  // useEffect(() => {
  //   if (Array.isArray(Common?.Country) && Location?.country_code) {
  //     const country = Common?.Country.find((item) => item.CountryCode === Location.country_code)
  //     setFieldValue("DialCode", country?.DialCode)
  //     setFieldValue("CountryCodeID", country?.ID)
  //     setMinMobileLength(country?.NumbersLimit)
  //   }

  // }, [Location, Common?.Country])

  // useEffect(() => {
  //   validateField()

  // }, [minMobileLength])

  return (
    <>
      <Dialog fullWidth maxWidth="xs" open={open} onClose={() => setOpen(false)}>
        <DialogTitle>
          <Box>
            <Typography variant="subtitle" fontWeight={500} color="white">
              {Translation?.AddFriendDetails}
            </Typography>
            <Typography>
              {Translation?.DirectlyJoinCodedPlus}
            </Typography>
          </Box>
          <IconButton onClick={() => setOpen(false)}>
            {" "}
            <PrimaryIcon
              icon={CloseIcon}
              color="white"
              height="14px"
              width="14px"
            />{" "}
          </IconButton>{" "}
        </DialogTitle>
        <form onSubmit={handleSubmit}>
          <DialogContent>
            <Grid2 display={"flex"} flexDirection={"column"} gap="16px">
              { Array.isArray(friendDetails) && friendDetails.length > 0 && friendDetails.map((item, index) => {
                return (
                  <Box
                    display={"flex"}
                    flexDirection={""}
                    gap="5px"
                    justifyContent={"space-between"}
                    sx={(theme) => ({
                      padding: "16px 16px",
                      borderRadius: "8px",
                      background: theme.palette.background.default
                    })}
                  >
                  <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap="10px">
                    <Typography variant="subtitle" 
                      sx={(theme) => ({
                      padding: "4px 8px",
                      borderRadius: "8px",
                      background: theme.palette.background.blueLight
                    })}
                      
                    >{index + 1}</Typography>
                    <Typography 
                      variant="body"
                      fontWeight={500}
                    >
                      {item.FullName}
                    </Typography>
                    </Box>
                    <Box display={"flex"} alignItems={"center"} gap="10px">
                      <IconButton
                        onClick={() => editFriendDetail(item, index)}
                        size="small"
                      >
                        <PrimaryIcon
                          width="16px"
                          height="16px"
                          icon={EditIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                      <IconButton
                        onClick={() => deleteFriendDetail(item, index)}
                        size="small"
                      >
                        <PrimaryIcon
                          width="16px"
                          height="16px"
                          icon={DeleteIcon}
                          cursor="pointer"
                        />
                      </IconButton>
                  </Box>
                </Box>
                )
              }) }

              { tab === 1 && <>
                  <FormControl fullWidth>
                    <FormLabel color="secondary" required label>
                      {Translation?.Name}
                    </FormLabel>
                    <TextField
                      name="FullName"
                      value={values.FullName}
                      onBlur={handleBlur}
                      onChange={handleChange}
                      placeholder={Translation?.EnterYourFriendName}
                      error={touched.FullName && errors.FullName}
                      helperText={touched.FullName && errors.FullName && errors.FullName}
                      size="small"
                      fullWidth
                    />
                  </FormControl>
                  <PhoneNumberInput
                    label={Translation?.PhoneNumber}
                    value={values.Mobile}
                    dialCodeValue={values.DialCode}
                    min={minMobileLength}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    placeholder={Translation?.EnterYourFriendContactNumber}
                    onBlur={() => setFieldTouched("DialCode", true)}
                    onChange={(value) => {
                      setFieldTouched("Mobile", true)
                      setFieldValue("DialCode", value?.DialCode)
                      setFieldValue("CountryCodeID", value?.ID)
                      setMinMobileLength(value?.NumbersLimit)
                    }}
                    error={touched.Mobile && errors.Mobile && errors.Mobile}
                  />
              
                  <FormControl fullWidth>
                    <FormLabel color="secondary" label>
                      {`${Translation?.FriendEmail} (${Translation?.Optional})`} 
                    </FormLabel>
                    <TextField
                      name="Email"
                      value={values.Email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      placeholder={Translation?.EnterYourFriendEmail}
                      error={touched.Email && errors.Email}
                      helperText={touched.Email && errors.Email && errors.Email}
                      size="small"
                      fullWidth
                    />
                  </FormControl>
                </>
              }

            </Grid2> 
            
            { tab === 2 && <>
              <Grid2 sx={{mt: "16px"}}>
                <Button startIcon={
                  <PrimaryIcon 
                    icon={PlusIcon}
                    height="12px"
                    color="primary"
                  /> } 
                  variant="outlined" 
                  onClick={addFriendDetail}>
                  {Translation?.AddAnother}
                </Button>
              </Grid2>
              <Grid2 sx={{mt: "16px"}}>
                <Typography  
                  display={"flex"}
                  alignItems={"center"}
                  gap="8px" variant="body">
                  <PrimaryIcon 
                    icon={AlertIcon}
                    width="24px" height="24px"
                  />

                  {Translation?.ReferralAgreeCondition}
                </Typography>
              </Grid2>
            </> } 
          </DialogContent>
          <DialogActions align="right">
          { tab === 1 ? <>
            <Button
              color="secondary"
              variant="outlined"
              onClick={() => {
                friendIndex >= 0 ? setTab(2) :
                handleClose()
              }}
            >
              {Translation?.ReferralCancel}
            </Button>
            <Button type="submit" variant="contained">{Translation?.ReferralNext}</Button>
          </> : tab === 2 ? 
            <Button variant="contained" onClick={onSubmit} fullWidth>
              {Translation?.Submit}
            </Button> : <></>
          }
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default FriendsDetail;
